/**
 * Service field configuration - matches ServiceType.VALID_SERVICE_FIELDS from backend.
 * Base fields (always shown when allowed_fields is null): name, phone, email, address, image
 */
export const BASE_FIELDS = ['name', 'phone', 'email', 'address', 'image'];

/** Optional fields that can be added to allowed_fields (beyond base) */
export const OPTIONAL_FIELDS = [
    'company_name',
    'no_mle',
    'date_inscription',
    'prenoms_and_nom',
    'cat',
    'titre',
    'raison_sociale_and_addresses',
    'dg',
    'department',
    'region',
    'no',
];

export const VALID_SERVICE_FIELDS = [
    'name',
    'phone',
    'email',
    'address',
    'company_name',
    'no_mle',
    'date_inscription',
    'prenoms_and_nom',
    'cat',
    'titre',
    'raison_sociale_and_addresses',
    'dg',
    'department',
    'region',
    'no',
];

/** Human-readable labels for each field */
export const FIELD_LABELS = {
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    image: 'Image',
    company_name: 'Company Name',
    no_mle: 'No MLE',
    date_inscription: 'Date Inscription',
    prenoms_and_nom: 'Prenoms and Nom',
    cat: 'CAT',
    titre: 'Titre',
    raison_sociale_and_addresses: 'Raison Sociale and Addresses',
    dg: 'DG',
    department: 'Department',
    region: 'Region',
    no: 'No',
};

/** Input type per field (text, email, date, textarea) */
export const FIELD_INPUT_TYPES = {
    name: 'text',
    phone: 'text',
    email: 'email',
    address: 'textarea',
    image: 'file',
    company_name: 'text',
    no_mle: 'text',
    date_inscription: 'date',
    prenoms_and_nom: 'text',
    cat: 'text',
    titre: 'text',
    raison_sociale_and_addresses: 'textarea',
    dg: 'text',
    department: 'text',
    region: 'text',
    no: 'text',
};

/**
 * Get the list of fields to display for a service type.
 * If allowed_fields is null/undefined/empty, returns base fields only.
 * Otherwise returns base fields + the extra allowed fields.
 */
export function getDisplayFields(allowedFields) {
    const extra = (!allowedFields || !Array.isArray(allowedFields) || allowedFields.length === 0)
        ? []
        : allowedFields.filter(f => VALID_SERVICE_FIELDS.includes(f));
    return [...BASE_FIELDS, ...extra];
}
